import Vue from "vue";
import { LOCAL_STORAGE_KEY } from "@/config";
import getCookie from "@/utils/getCookie";
import jwtDecode from "jwt-decode";
import { REFRESH_TOKEN_URL } from "@/config/apiEndpoints";
import apiRequest from "@/utils/apiRequest";

export const state = {
  ...getSavedState(),
};

export const getters = {
  user: (state) => state.user,
  token: (state) => state.token,
};

export const mutations = {
  STORE_USER(state, user) {
    state.user = user;
  },
  STORE_TOKEN(state, token) {
    state.token = token;
  },
};

export const actions = {
  storeUser({ commit }, user) {
    commit("STORE_USER", user);
  },
  storeToken({ commit }, token = null) {
    if (token) {
      commit("STORE_TOKEN", token);
    } else {
      commit("STORE_TOKEN", this.$cookies.get(LOCAL_STORAGE_KEY));
    }
  },
  logout({ commit }) {
    commit("STORE_TOKEN", null);
    commit("STORE_USER", null);
    Vue.$cookies.remove("user");
  },

  storeUserInfo({ commit }) {
    const user = JSON.parse(this.$cookies.get(LOCAL_STORAGE_KEY));
    commit("STORE_USER", user);
  },

  refreshAccessTokenOnOrgProjChange(
    { dispatch, getters },
    { orgId, projectId }
  ) {
    const body = {
      user_id: getters["user"].user_id,
      org_id: orgId,
    };
    if (projectId) {
      body.project_id = projectId;
    }
    return new Promise((resolve, reject) => {
      apiRequest({
        url: REFRESH_TOKEN_URL,
        method: "POST",
        data: { ...body },
      })
        .then((response) => {
          const user = jwtDecode(response.data.access_token);
          Vue.$cookies.remove("user");
          Vue.$cookies.set("user", response.data.access_token);
          dispatch("storeUser", user);
          dispatch("storeToken", response.data.access_token);
          resolve(response.data.access_token);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};

function getSavedState() {
  const token = getCookie(LOCAL_STORAGE_KEY);
  let user = {};

  if (token) {
    user = jwtDecode(token);
  }

  return {
    token,
    user,
  };
}
